<template>
  <w-sliding-popup ref="slidingPopup" :title="threadName" width="800px" @close="closePopup">
    <div slot="content">
      <el-row type="flex" class="title-bar" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4 tit">
            쓰레드 상세정보
          </div>
          <el-button class="mr-l4" @click="loadData"><i class="far fa-sync-alt"/></el-button>
        </div>
        <div>
          <el-button :disabled="!allowAction" @click="executeThreadControl('interrupt','차단')">차단</el-button>
          <el-button :disabled="!allowAction" @click="executeThreadControl('stop', '종료')">종료</el-button>
          <el-button :disabled="!allowAction" @click="executeThreadControl('suspend', '중지')">중지</el-button>
          <el-button :disabled="!allowAction" @click="executeThreadControl('resume', '재개')">재개</el-button>
        </div>
      </el-row>
      <el-row type="flex" :gutter="20" class="mr-b20">
        <el-col :span="12">
          <div class="list form-list">
            <el-form :model="threadInfo" ref="threadInfoForm" label-width="160px">
              <el-form-item label="쓰레드 아이디">
                {{getValueAfterCheckEmpty(threadInfo.ThreadId)}}
              </el-form-item>
              <el-form-item label="쓰레드 이름">
                {{getValueAfterCheckEmpty(threadInfo.ThreadName)}}
              </el-form-item>
              <el-form-item label="쓰레드 사용자 시간">
                {{convertMillisecondsValue(threadInfo.ThreadUserTime)}}
              </el-form-item>
              <el-form-item label="Waited 수">
                {{convertCountValue(threadInfo.WaitedCount)}}
              </el-form-item>
              <el-form-item label="Waited 시간">
                {{convertMillisecondsValue(threadInfo.WaitedTime)}}
              </el-form-item>
              <el-form-item label="쓰레드 CPU 시간">
                {{convertValue(threadInfo.ThreadCpuTime)}}
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span = "12">
          <div class="list form-list" >
            <el-form :model="threadInfo" ref="threadInfoForm" label-width="160px">
              <el-form-item label="Blocked 수">
                {{convertCountValue(threadInfo.BlockedCount)}}
              </el-form-item>
              <el-form-item label="Blocked 시간">
                {{convertMillisecondsValue(threadInfo.BlockedTime)}}
              </el-form-item>
              <el-form-item label="Lock Owner 아이디">
                {{convertMinusTextValue(threadInfo.LockOwnerId)}}
              </el-form-item>
              <el-form-item label="Lock Owner 이름">
                {{getValueAfterCheckEmpty(threadInfo.LockOwnerName)}}
              </el-form-item>
              <el-form-item label="상태">
                {{getValueAfterCheckEmpty(threadInfo.State)}}
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
      <div class="title-bar title-h4 mr-r4 tit">스택 트레이스</div>
      <el-input readonly type="textarea" v-model="threadInfo.StackTrace" :rows="25"></el-input>
    </div>
  </w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil } from 'lodash';
import moment from 'moment';
import { calcUptime } from '@/utils/date';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import ApmConfigAPI from '@/api/config/apm/apm-info';
import { convertValuByUnit } from '@/utils/number';

export default {
  name: 'WThreadDetailPopup',
  props: {
    threadParams: {
      type: Object,
    },
  },
  data() {
    return {
      allowAction: true,
      threadInfo: {
        BlockedCount: null,
        BlockedTime: null,
        LockOwnerId: null,
        LockOwnerName: null,
        State: null,
        ThreadCpuTime: null,
        ThreadId: null,
        ThreadName: null,
        ThreadUserTime: null,
        WaitedCount: null,
        WaitedTime: null,
        StackTrace: null,
      },
      threadName: '',
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    threadParams: {
      handler() {
        if (Object.entries(this.threadParams).length > 0) {
          this.initData();
          this.loadData();
          this.threadName = this.threadParams.name;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getValueAfterCheckEmpty,
    initData() {
      this.threadInfo = {
        BlockedCount: null,
        BlockedTime: null,
        LockOwnerId: null,
        LockOwnerName: null,
        State: null,
        ThreadCpuTime: null,
        ThreadId: null,
        ThreadName: null,
        ThreadUserTime: null,
        WaitedCount: null,
        WaitedTime: null,
        StackTrace: null,
      };
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    convertCountValue(value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'count', true, false, true);
    },
    convertMinusTextValue(value) {
      return (value === '-1') ? EMPTY_TEXT : value;
    },
    convertMillisecondsValue(value) {
      return (value === '-1') ? EMPTY_TEXT : convertValuByUnit(value, 'ms', true, true);
    },
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
        threadId: this.threadParams.id,
        txid: this.threadParams.txid,
      };
      ApmConfigAPI.getThreadDetail(params).then((response) => {
        if (response.data.success) {
          this.threadInfo = response.data.data;
          this.allowAction = !isNil(response.data.data.allowAction) ? response.data.data.allowAction : false;
          // this.fileDumpContent = response.data.data;
        }
      });
    },
    executeThreadControl(action, messageTitle) {
      const params = {
        objId: this.selectedNode.obj.objId,
        threadId: this.threadParams.id,
        action,
      };
      const confirmContent = {
        interrupt: '차단하시겠습니까?<br />(SecurityException이 발생할 수 있습니다.)',
        stop: '종료하시겠습니까?<br />(이 동작은 사전 테스트가 필요합니다.)',
        suspend: '중지하시겠습니까?<br />(SecurityException이 발생할 수 있습니다.)',
        resume: '쓰레드를 재개하시겠습니까?',
      };

      this.$confirm(confirmContent[action], msgUtil.title.CONFIRM, {
        ...msgUtil.defaultConfirmButton,
        dangerouslyUseHTMLString: true,
      }).then(() => {
        ApmConfigAPI.executeThreadControl(params).then((response) => {
          if (response.data.success) {
            this.$emit('reload');
            this.closePopup();
          }
          this.$message(msgUtil.getResultMsgData(msgUtil.action.RUN, messageTitle, response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.RUN, messageTitle, false));
        });
      }).catch(() => {});
    },
    convertValue(value) {
      if (value > 0) {
        const convertTime = moment();
        const substarctTargetTime = moment();
        substarctTargetTime.year(1970).month(0).date(1);
        substarctTargetTime.hours(0).minutes(0).seconds(0).milliseconds(0);
        convertTime.year(1970).month(0).date(1);
        convertTime.hours(0).minutes(0).seconds(value).milliseconds(0);

        return calcUptime(substarctTargetTime, convertTime);
      }
      return EMPTY_TEXT;
      // return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null, true);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/config/node/apm/popup/ThreadDetailPopup.vue